import React, { PropTypes } from 'react';
import AnswerItem from './AnswerItem';

const NoItem = () => (
  <div className="ui segment">
    <div className="ui message">Aucune réponse. Veuillez en ajouter une.</div>
  </div>
);

const AnswerList = ({ question, answers, ...rest }) => {
  if (answers.length) {
    return (
      <div className="ui segment">
        <div className="ui items">
          {answers.map(answer => (
            <AnswerItem
              key={answer.id}
              question={question}
              answer={answer}
              answerCount={answers.length}
              {...rest}
            />
          ))}
        </div>
      </div>
    );
  }

  return <NoItem />;
};

AnswerList.propTypes = {
  question: PropTypes.object.isRequired,
  answers: PropTypes.array.isRequired,
};

export default AnswerList;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/AnswerList.js